import { render } from "./WarrantyClaimContainer.vue?vue&type=template&id=1a9345a4"
import script from "./WarrantyClaimContainer.vue?vue&type=script&lang=js"
export * from "./WarrantyClaimContainer.vue?vue&type=script&lang=js"

import "./WarrantyClaimContainer.vue?vue&type=style&index=0&id=1a9345a4&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__